
import MainLayout from "@/components/layout/MainLayout";
import PersonalityTestCard from "@/components/personality/PersonalityTestCard";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import PageSEO from "@/components/seo/PageSEO";

const PersonalityTests = () => {
  const tests = [
    {
      id: "big-five",
      title: "Big Five",
      description: "Descubra os cinco principais traços da sua personalidade através de uma avaliação científica e validada.",
      estimatedTime: "10-15 min",
      path: "/testes-personalidade/big-five",
      completedAt: null,
    },
    {
      id: "young-schemas",
      title: "Esquemas de Young",
      description: "Identifique padrões emocionais profundos que influenciam seus relacionamentos e comportamentos.",
      estimatedTime: "15-20 min", 
      path: "/testes-personalidade/young-schemas",
      completedAt: null,
    }
  ];

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://youcalm.org/app"
    },
    {
      position: 2,
      name: "Testes de Personalidade",
      item: "https://youcalm.org/testes-personalidade"
    }
  ];

  const structuredData = {
    "@type": "Course",
    "name": "Testes de Personalidade YouCalm",
    "description": "Conjunto completo de avaliações psicológicas científicas para autoconhecimento profundo e crescimento pessoal.",
    "provider": {
      "@type": "Organization",
      "name": "YouCalm"
    },
    "educationalLevel": "Beginner",
    "courseMode": "online",
    "hasCourseInstance": [
      {
        "@type": "CourseInstance",
        "name": "Teste Big Five",
        "description": "Avaliação dos cinco grandes fatores de personalidade"
      },
      {
        "@type": "CourseInstance", 
        "name": "Esquemas de Young",
        "description": "Identificação de padrões emocionais profundos"
      }
    ]
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Testes de Personalidade - YouCalm | Autoconhecimento Científico Completo"
        description="Descubra sua personalidade com nossos testes científicos validados: Big Five e Esquemas de Young. Obtenha insights profundos para crescimento pessoal e profissional."
        canonicalUrl="https://youcalm.org/testes-personalidade"
        keywords="testes personalidade, big five, esquemas young, autoconhecimento, avaliação psicológica, crescimento pessoal"
        pageName="Testes de Personalidade"
        pageType="Course"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container mx-auto py-8">
        <Card>
          <CardHeader>
            <CardTitle>Testes de Personalidade</CardTitle>
            <CardDescription>
              Descubra mais sobre você mesmo através de nossos testes científicos validados.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4 md:grid-cols-2">
            {tests.map((test, index) => (
              <PersonalityTestCard
                key={test.id}
                result={{
                  id: test.id,
                  type: test.id,
                  typeName: test.title,
                  icon: test.id === 'big-five' ? require('lucide-react').Brain : require('lucide-react').Heart,
                  date: "Não realizado",
                  scores: {},
                  summary: test.description,
                  createdAt: new Date(),
                  updatedAt: new Date()
                }}
                isFirst={index === 0}
                onViewResult={() => window.location.href = test.path}
              />
            ))}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PersonalityTests;
